const textContent = {
  espanol: {
    inicio: "Inicio",
    habilidades: "Habilidades",
    proyectos: "Proyectos",
    certificados: "Certificados",
    contacto: "Contacto",
    esp_main: "Bienvenido a mi portafolio",
    esp_sobre_mi: "Sobre mí",
    esp_descripcion: "Soy un programador junior apasionado por la tecnología, recién graduado y listo para aplicar mis habilidades en proyectos desafiantes. Mi fuerza radica en aprender constantemente, y actualmente estoy inmerso en proyectos personales para ampliar mi conocimiento. Colaborador comprometido y solucionador de problemas, busco un equipo que comparta mi visión de innovación y calidad en la programación. ¡Conéctame en LinkedIn si buscas un talento motivado para llevar tus proyectos al siguiente nivel!",
    esp_explora_proyectos: "¡Explora mis proyectos y conoce más sobre mí en Contacto!",
  },
  english: {
    inicio: "Home",
    habilidades: "Skills",
    proyectos: "Projects",
    certificados: "Certificates",
    contacto: "Contact",
    esp_main: "Welcome to my portfolio",
    esp_sobre_mi: "About me",
    esp_descripcion: "I am a junior programmer passionate about technology, recently graduated and ready to apply my skills in challenging projects. My strength lies in constantly learning, and I am currently immersed in personal projects to expand my knowledge. Committed collaborator and problem solver, I am looking for a team that shares my vision of innovation and quality in programming. Connect with me on LinkedIn if you are looking for a motivated talent to take your projects to the next level!",
    esp_explora_proyectos: "¡Explore my projects and learn more about me on Contact!",
  },
};

export default textContent;


